import { html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import './Buttons.css';

export const Button = ({
  primary,
  backgroundColor = null,
  backgroundImage = null,
  size,
  label,
  onClick,
  fontSize,
  fontFamily,
  borderWidth,
  borderColor,
  borderRadius,
  textColor,
  textAlign,
  width,
  height,
  fontStyle,    
  fontWeight,
  cursor 
}) => {
  const mode = primary ? 'storybook-button--primary' : 'storybook-button--secondary';

  const styles = {
    backgroundColor,
    backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none', 
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    fontSize,
    fontFamily,
    borderWidth,
    borderColor,
    borderStyle: 'solid',
    borderRadius,
    color: textColor,
    textAlign,
    width,
    height,
    fontStyle,    
    fontWeight,
    cursor: 'pointer'   
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      console.log('enter is pressed')
      onClick();
    }
  };

  return html`
    <button
      type="button"
      class=${['storybook-button', `storybook-button--${size || 'medium'}`, mode].join(' ')}
      style='${styleMap(styles)}'
      @click=${onClick}
      @keydown=${handleKeyDown}
    >
      ${label}
    </button>
  `;
};
